import React from "react";
import { motion } from "framer-motion";
import { CTAButton } from "@/components/landing/kit";
import SiteFooter from "@/components/landing/SiteFooter";

const FinalCta = () => (
  <>
    <section
      id="apply"
      className="relative overflow-hidden bg-gradient-to-b from-[#F9FAFC] to-[#EEF2FF] py-28 sm:py-40"
    >
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(45,91,255,0.10),transparent_60%)]" />
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[500px] w-[800px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#2D5BFF]/[0.08] blur-[150px]" />

      <div className="relative z-10 mx-auto max-w-4xl px-5 text-center sm:px-6">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-6 font-heading text-xs font-bold uppercase tracking-[0.3em] text-[#2D5BFF]"
        >
          Your next chapter starts with one call
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="text-balance font-heading text-5xl font-black leading-[0.92] tracking-tight text-[#0F1117] sm:text-7xl lg:text-8xl"
        >
          Ready to scale <span className="text-[#2D5BFF]">without the stress?</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-[#4B5262] sm:text-lg"
        >
          Book your free strategy call. We&apos;ll audit your store, map your growth, and
          show you exactly what a real partner looks like.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.25 }}
          className="mt-10 flex flex-col items-center gap-4"
        >
          <CTAButton size="xl" testId="final-cta-button">
            Book My Free Strategy Call
          </CTAButton>
          <span className="text-xs text-[#858D9E]">
            Free &middot; No obligation &middot; Results vary; no income is promised
          </span>
        </motion.div>
      </div>
    </section>

    <SiteFooter />
  </>
);

export default FinalCta;
